import { Model, Attr, BelongsTo } from 'spraypaint'

import ApplicationRecord from '@/models/ApplicationRecord'
import { Caretaker } from '@/models/index'

@Model()
export default class Pricing extends ApplicationRecord {
  static jsonapiType = 'pricings'

  @Attr() id!: string
  @Attr() createdAt!: string
  @Attr() pricingItem!: string
  @Attr() value!: number
  @Attr() unit!: string
  @Attr() validFrom!: string
  @Attr() validTo!: string | null
  @Attr() status!: string
  @Attr() caretakerId!: string | null

  @BelongsTo() caretaker!: Caretaker
}
